import type { ReactNode } from 'react'

/** A small status chip. Colour never carries meaning on its own: it has words. */
export function Pill({
  tone,
  children,
}: {
  tone: 'wait' | 'done' | 'todo' | 'back'
  children: ReactNode
}) {
  const styles: Record<string, string> = {
    wait: 'bg-gold-soft text-gold',
    done: 'bg-mint-soft text-mint',
    todo: 'bg-teal-soft text-teal',
    back: 'bg-coral-soft text-coral',
  }
  return (
    <span className={`inline-block rounded-full px-3 py-1 text-sm font-bold ${styles[tone] ?? ''}`}>
      {children}
    </span>
  )
}
